import styled from '@emotion/styled';
import { Colors, Shadows } from '@zapier/design-system';
import { Link } from 'components/Link/Link';
import {
  EventAction,
  InteractionName,
  OptionSelected,
  useAvroTracking,
} from 'tracking';

type UniversalNavLinkType = {
  href: string;
  text: string;
  description?: string;
};

type Props = {
  /**
   * Array of links to render within dropdown menu.
   */
  links: Array<UniversalNavLinkType>;
  onChoose: (href: string, event: React.MouseEvent) => void;
};

export const Submenu = (props: Props) => {
  const { emitUserInteractionEvent } = useAvroTracking();

  return (
    <Outer>
      <List>
        {props.links.map(({ href, text }) => (
          <li key={text}>
            <LinkWrapper>
              <Link href={href}>
                <LinkInner
                  onClick={(e) => {
                    emitUserInteractionEvent({
                      event_action: EventAction.click,
                      interaction_name: InteractionName.navigation,
                      interaction_raw_text: text,
                      option_selected: OptionSelected.sub_nav_link,
                      destination_url_address: href,
                    });
                    props.onChoose(href, e);
                  }}
                >
                  <LinkTitle>{text}</LinkTitle>
                </LinkInner>
              </Link>
            </LinkWrapper>
          </li>
        ))}
      </List>
    </Outer>
  );
};

const Outer = styled.div`
  background-color: ${Colors.neutral100};
  border-radius: 3px;
  padding: 10px;
  box-shadow: ${Shadows.elevation20};
`;

const LinkInner = styled.div`
  transform: translateY(1px);
`;

const LinkTitle = styled.p`
  font-weight: 500;
  padding: 10px;
`;

const LinkWrapper = styled.div`
  display: block;
  cursor: pointer;
  border-radius: 3px;
  color: ${Colors.neutral700};
  line-height: 20px;
  font-size: 14px;

  &:hover,
  &:focus {
    color: ${Colors.blueJeans};
    background-color: ${Colors.acidWash};
  }
`;

const List = styled.ul`
  display: grid;
  grid-template-columns: 100%;
  gap: 8px};
`;
